import { render } from "./SocialButtons.vue?vue&type=template&id=09707966&scoped=true"
import script from "./SocialButtons.vue?vue&type=script&lang=js"
export * from "./SocialButtons.vue?vue&type=script&lang=js"

import "./SocialButtons.vue?vue&type=style&index=0&id=09707966&scoped=true&lang=css"

import exportComponent from "/Users/gabrielvoirol/git_projects/df_wpheadless/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09707966"]])

export default __exports__